<template>
  <header class="text-center mt-4 mb-5">
    <router-link :to="{ name: 'home' }"><img width="120" height="39" src="@/assets/images/nyonyacooking.svg"></router-link>
  </header>
</template>

<script>
export default {

}
</script>
